module.exports = __webpack_public_path__ + "img/notification-empty.773e9cb4.png";